<label>Default template:</label>
@if(templates) {
  <section>
    <app-kp-autocomplete
      [filterFunction]="filterFn"
      [selected]="selectedName"
      [placeholder]="'Search templates...'"
      [position]="'initial'"
      [dataLoading]="!templates"
      [disabled]="!templates"
      (selectedChange)="onTemplateSelected($event)"
      (inputCleared)="onInputCleared()">
    </app-kp-autocomplete>
    @if(noTemplatesAvailable) {
      <p>No templates found</p>
    }
  </section>
} @else {
  <p>Loading templates...</p>
}
